import UserAdminUser from "./UserAdminUser-container";

/**
 * Export the top level component UserAdminUser-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default UserAdminUser;
